import { HardwareTypes, HardwareTypesWithLabels } from '../../overview/constants'
import template from './taas-add.html'

const taasAdd = {
  bindings: {
    item: '<',
    relationWarning: '<',
    subscriptionLengthWarning: '<',
    numberOfSubscriptionsWarning: '<',
    hardwareTypesWarning: '<',
    paymentReferenceWarning: '<',
    relations: '<',
    onRelationChange: '&',
    onClearWarning: '&',
    onDataChange: '&',
  },
  template,
  controller: /* @ngInject */ class SubscriptionsAddController {
    searchRelation ({ searchTerm }) {
      this.subRefs = []
      if (searchTerm.length < 3) {
        this.relations = []
      }
      this.onRelationChange({ $event: { searchTerm } })
    }

    hardwareTypes = HardwareTypesWithLabels

    setRelation ({ item }) {
      this.relationWarning = null
      this.data.relation = item
      this.forwardData()
    }

    getHardwareIconPath () {
      return this.data.hardwareType === "ROBOT" ? 'robot' : this.data.hardwareType === "VOICE_ASSISTANT" ? 'voice-assistant' : 'unknown'
    }

    get getHardwareTypeItem() {
      return this.hardwareTypes.find(p => p.value === this.data.hardwareType)
    }

    setHardwareType ({item}) {
      this.hardwareTypesWarning = item.value ? null : 'Select hardware type'
      this.data.hardwareType = item.value
      this.forwardData()
    }

    setAmountOfSubscriptions ({ value }) {
      this.numberOfSubscriptionsWarning = value ? null : 'Add the amount of subscriptions'
      this.data.numberOfSubscriptions = value
      this.forwardData()
    }

    setSubscriptionNotes ({ value }) {
      this.data.notes = value
    }

    clearWarning (name) {
      this.onClearWarning({ $event: { name } })
    }

    forwardData () {
      this.onDataChange({ $event: { data: this.data } })
    }

    $onChanges (changes) {
      if (changes.data) {
        this.data = angular.copy(this.data)
      }
    }

    $onInit () {
      this.data = {}
      if(this.item) {
        this.setRelation({item: this.item})
      }
    }
  }
}

export default taasAdd
